import React from 'react';
import { SPONSORS } from '../data/sponsors';
import { BONUS_SPONSORS } from '../data/sponsors';

export const SideSponsorSlider = () => {
  const allSponsors = [...SPONSORS, ...BONUS_SPONSORS];
  const tripled = [...allSponsors, ...allSponsors, ...allSponsors];

  return (
    <>
      <div className="side-slider side-slider-left" data-testid="side-sponsor-slider-left">
        <div className="side-slider-track">
          {tripled.map((sponsor, i) => (
            <a
              key={`left-${sponsor.id}-${i}`}
              href={sponsor.affiliateUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="side-slider-item"
              aria-label={`${sponsor.name}`}
            >
              <img src={sponsor.logo} alt={sponsor.name} loading="lazy" />
            </a>
          ))}
        </div>
      </div>
      <div className="side-slider side-slider-right" data-testid="side-sponsor-slider-right">
        <div className="side-slider-track">
          {tripled.map((sponsor, i) => (
            <a
              key={`right-${sponsor.id}-${i}`}
              href={sponsor.affiliateUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="side-slider-item"
              aria-label={`${sponsor.name}`}
            >
              <img src={sponsor.logo} alt={sponsor.name} loading="lazy" />
            </a>
          ))}
        </div>
      </div>
    </>
  );
};
